import HistoryIcon from '@mui/icons-material/HistoryOutlined';
import { IconButton } from '@mui/material';

import { GRID_AREA_HISTORY_BUTTON } from 'pages/ParentHelper/components/Chat/components/Header/constants';
import { useDialogContext } from 'pages/ParentHelper/providers/DialogProvider/hooks';

export const HistoryButton = () => {
  const { onOpen } = useDialogContext();

  return (
    <IconButton
      sx={{ gridArea: GRID_AREA_HISTORY_BUTTON, p: 1.5 }}
      onClick={onOpen}
    >
      <HistoryIcon />
    </IconButton>
  );
};
